import { ApiProjectProgressSummary } from "avvir";

import { AvvirEvent } from "type_aliases";

export type ProjectProgressSummaryLoadedEvent = AvvirEvent<typeof PROJECT_PROGRESS_SUMMARY_LOADED, {
  projectId: string,
  summary: ApiProjectProgressSummary
}>

const projectProgressSummaryLoaded = (projectId: string, summary: ApiProjectProgressSummary): ProjectProgressSummaryLoadedEvent => ({
  type: PROJECT_PROGRESS_SUMMARY_LOADED,
  payload: {
    projectId,
    summary
  }
});

export const PROJECT_PROGRESS_SUMMARY_LOADED = "project_progress_summary_loaded";

export default projectProgressSummaryLoaded;
